import React from 'react';
import PaymentMethodsTable from './PaymentMethodsTable';

const PaymentMethods = () => {
  return <PaymentMethodsTable />;
};

export default PaymentMethods;